import { JobFromAPI } from '../types';
import { transformJob } from './api-transforms';
import apiRequest from './apiRequest';

type JobPostPayload = {
  existingAnimationNumber: number;
  existingJobID: string;
  selectedAnimationNumber?: number;
  selectedTrimStart?: number;
  selectedTrimEnd?: number;
  trimStart?: number;
  trimEnd?: number;
  wsConnectionID: string;
  wsHttpEndpoint: string;
};

export default async function postSessionFromExistingJob(
  sessionID: string,
  props: JobPostPayload,
) {
  const { data, error } = await apiRequest<JobFromAPI>(
    'mogen-orchestration',
    `/sessions/${sessionID}/fromExistingJob`,
    {
      method: 'POST',
      body: JSON.stringify(props),
    },
  );

  return {
    data: transformJob(data),
    error,
  };
}
